import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsersLowBalanceComponent } from './users-low-balance/users-low-balance.component';


const routes: Routes = [
  {
    path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'ads', loadChildren: () => import('./ads/ads.module').then(m => m.AdsModule)
  },
  {
    path: 'reviews', loadChildren: () => import('./reviews/reviews.module').then(m => m.ReviewsModule)
  },
  {
    path: 'review-orders', loadChildren: () => import('./review-orders/review-orders.module').then(m => m.ReviewOrdersModule)
  },
  {
    path: 'payments', loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsModule)
  },
  {
    path: 'impressions', loadChildren: () => import('./impressions/impressions.module').then(m => m.ImpressionsModule)
  },
  {
    path: 'clicks', loadChildren: () => import('./clicks/clicks.module').then(m => m.ClicksModule)
  },
  {
    path: 'subscriptions', loadChildren: () => import('./subscriptions/subscriptions.module').then(m => m.SubscriptionsModule)
  },
  {
    path: 'followers', loadChildren: () => import('./followers/followers.module').then(m => m.FollowersModule)
  },
  {
    path: 'video-analyze-orders', loadChildren: () => import('./video-analyze-orders/video-analyze-orders.module').then(m => m.VideoAnalyzeOrdersModule)
  },
  {
    path: 'shorts', loadChildren: () => import('./shorts/shorts.module').then(m => m.ShortsModule)
  },
  {
    path: 'video-shorts', redirectTo: 'shorts', pathMatch: 'full'
  },
  {
    path: 'ai-orders', redirectTo: 'video-analyze-orders', pathMatch: 'full'
  },
  {
    path: 'users-low-balance', component: UsersLowBalanceComponent
  },
  {
    path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'coupons', loadChildren: () => import('./coupons/coupons.module').then(m => m.CouponsModule)
  },
  {
    path: 'transactions', loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
